package pl.finn.forms.ezw

import io.kvision.core.onEvent
import io.kvision.form.FormControl
import io.kvision.form.FormHorizontalRatio
import io.kvision.form.check.CheckBox
import io.kvision.form.select.Select
import io.kvision.form.select.selectOption
import io.kvision.form.text.ImaskOptions
import io.kvision.form.text.NumberMask
import io.kvision.form.text.PatternMask
import io.kvision.form.text.Text
import io.kvision.form.time.DateTime
import io.kvision.html.Div
import io.kvision.html.Label
import io.kvision.panel.FieldsetPanel
import pl.finn.forms.CommonData
import pl.finn.forms.POLE_WYMAGANE
import pl.finn.forms.fk02.DynamicFieldsValidator
import pl.finn.forms.utils.model.Util

class EzwComponents(dfv: DynamicFieldsValidator) {

  private val dynamicFieldsValidator = dfv

  fun fieldsetPanelDataOkres(field: DataLubPrzedzialDat, label: String, validationGroup: String? = null): FieldsetPanel {
    return FieldsetPanel(label).apply {
      add(dynamicFieldsValidator.add( //Text: dataOkresPowstaniaNaleznosci odDnia "od dnia"
        DateTime(
          value = field.odDnia,
          label = "od dnia",
          format = "YYYY-MM-DD"
        ).apply {
          onEvent {
            change = {
              field.odDnia = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
        POLE_WYMAGANE,
        validationGroup
      ))
      add( //Text: dataOkresPowstaniaNaleznosci doDnia "do dnia" //opcjonalne
        DateTime(
          value = field.doDnia,
          label = "do dnia",
          format = "YYYY-MM-DD"
        ).apply {
          onEvent {
            change = {
              field.doDnia = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        }
      )
    }
  }

  fun dateField(field: Data, label: String, required: Boolean = true): FormControl {
    val formControl = DateTime(
      value = field.data,
      label = label,
      format = "YYYY-MM-DD"
    ).apply {
      onEvent {
        change = {
          field.data = self.value
        }
      }
      styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
    }

    if (required) {
      formControl.flabel.addCssClass("required-label")
      return dynamicFieldsValidator.add(
        formControl,
        { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) ) },
        POLE_WYMAGANE
      )
    } else {
      return formControl
    }

  }

  fun amountField(field: Kwota, label: String, required: Boolean = true): FormControl {
    //validation TKwota2Nieujemna
    val formControl = Text(
      value = field.kwota,
      label = label
    ).apply {
      onEvent {
        change = {
          field.kwota = self.value
        }
        blur = {
          self.maskOptions = ImaskOptions(number =
          NumberMask(
            scale = 2,
            signed = false,
            thousandsSeparator = ' ',
            padFractionalZeros = true,
            normalizeZeros = true,
            radix = ',',
            mapToRadix = listOf<Char>('.')
          )
          )
        }
        focus = {
          self.maskOptions = ImaskOptions(number =
          NumberMask(
            scale = 2,
            signed = false,
            thousandsSeparator = ' ',
            padFractionalZeros = false,
            normalizeZeros = false,
            radix = ',',
            mapToRadix = listOf<Char>('.')
          )
          )
        }
      }
      maskOptions = ImaskOptions(
        number = NumberMask(
          scale = 2,
          signed = false,
          thousandsSeparator = ' ',
          padFractionalZeros = true,
          normalizeZeros = true,
          radix = ',',
          mapToRadix = listOf<Char>('.')
        )
      )
      styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
    }
    if (required) {
      formControl.flabel.addCssClass("required-label")
      return dynamicFieldsValidator.add(
        formControl,
        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank())) },
        POLE_WYMAGANE
      )
    } else {
      return formControl
    }

  }

  fun checkBoxPosiadaBlok(blok: BlokOpcjonalny, blokDiv: Div, label: String = "Posiada blok"): CheckBox {
    return CheckBox(
      value = blok.posiadaBlok,
      label = label,
      rich = true
    ).apply {
      onEvent {
        change = {
          blok.posiadaBlok = self.value
          if (self.value) {
            blokDiv.show()
          } else {
            blokDiv.hide()
          }
        }
      }
    }
  }

  fun fieldsetPanelAdres(field: Adres): FieldsetPanel {
    return FieldsetPanel("Adres").apply {
      var adresPolski = Div().apply {
        visible = field.kodKraju == "PL"
        add(fieldsetPanelAdresPolski(field.adresPolski))
      }
      var adresZagraniczny = Div().apply {
        visible = field.kodKraju != null && field.kodKraju != "PL"
        add(fieldsetPanelAdresZagraniczny(field.adresZagraniczny))
      }
      add(dynamicFieldsValidator.add(
        Select(
          value = field.kodKraju,
          label = "Kod Kraju"
        ).apply {
          onEvent {
            change = {
              field.kodKraju = self.value
              if (self.value == "PL") {
                adresPolski.show()
                adresZagraniczny.hide()
              } else {
                adresPolski.hide()
                adresZagraniczny.show()
              }
            }
          }
          for ((key, value) in CommonData.countryCodeMap) {
            selectOption(value = key, label = value)
            liveSearch = true
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
        POLE_WYMAGANE
      ))
      add(adresPolski)
      add(adresZagraniczny)
    }
  }

  fun fieldsetPanelAdresPolski(field: AdresPolski): FieldsetPanel {
    return FieldsetPanel("Adres Polski").apply {
      add(dynamicFieldsValidator.add(
        Text( //VALIDATION TJednAdmin (MIN 1 MAX 36)
          value = field.wojewodztwo,
          label = "Województwo"
        ).apply {
          onEvent {
            change = {
              field.wojewodztwo = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) ) },
        POLE_WYMAGANE
      ))
      add(dynamicFieldsValidator.add(
        Text( //VALIDATION TJednAdmin (MIN 1 MAX 36)
          value = field.powiat,
          label = "Powiat"
        ).apply {
          onEvent {
            change = {
              field.powiat = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) ) },
        POLE_WYMAGANE
      ))
      add(dynamicFieldsValidator.add(
        Text( //VALIDATION TJednAdmin (MIN 1 MAX 36)
          value = field.gmina,
          label = "Gmina"
        ).apply {
          onEvent {
            change = {
              field.gmina = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) ) },
        POLE_WYMAGANE
      ))
      add(dynamicFieldsValidator.add(
        Text( //VALIDATION TMiejscowosc (MIN 1 MAX 56)
          value = field.miejscowosc,
          label = "Miejscowość"
        ).apply {
          onEvent {
            change = {
              field.miejscowosc = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) ) },
        POLE_WYMAGANE
      ))
      add(
        Text(  //VALIDATION TUlica ( MAX 65)
          value = field.ulica,
          label = "Ulica"
        ).apply {
          onEvent {
            change = {
              field.ulica = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        }
      )
      add(dynamicFieldsValidator.add(
        Text( //VALIDATION TNrBudynku ( MAX 9)  TODO EZW VALODATION ANOMALIUM POLE MUSI BYC DLA ADR POLSKIEGO CHOC CHYBA MOZE BYĆ DŁ 0
          value = field.nrDomu,
          label = "Nr domu"
        ).apply {
          onEvent {
            change = {
              field.nrDomu = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) ) },
        POLE_WYMAGANE
      ))
      add(
        Text( //VALIDATION TNrLokalu ( MAX 10)
          value = field.nrLokalu,
          label = "Nr lokalu"
        ).apply {
          onEvent {
            change = {
              field.nrLokalu = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        }
      )
      add(dynamicFieldsValidator.add(
        Text( //VALIDATION TKodPocztowy ( MAX 8)
          value = field.kodPocztowy,
          label = "Kod pocztowy"
        ).apply {
          onEvent {
            change = {
              field.kodPocztowy = self.value
            }
          }
          maskOptions = ImaskOptions(
            pattern = PatternMask(
              pattern = "00-000",
              lazy = false,
              eager = null,
              placeholderChar = '_',
              definitions = null,
              blocks = null
            )
          )
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> (!elem.isNullOrEmpty() && !elem.isBlank() && ("\\d{5}")?.toRegex()?.matches(elem) == true) },
        { elem -> (if( !elem.isNullOrEmpty() && !elem.isBlank() ) "Kod pocztowy powinien zawierać 5 cyfr" else POLE_WYMAGANE) },
      ))
    }
  }

  private fun fieldsetPanelAdresZagraniczny(field: AdresZagraniczny): FieldsetPanel {
    return FieldsetPanel("Adres Zagraniczny").apply {
      add(
        Text( //VALIDATION TKodPocztowy ( MAX 8)
          value = field.kodPocztowy,
          label = "Kod pocztowy"
        ).apply {
          onEvent {
            change = {
              field.kodPocztowy = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        }
      )
      add(dynamicFieldsValidator.add(
        Text( //VALIDATION TMiejscowosc (MIN 1 MAX 56)
          value = field.miejscowosc,
          label = "Miejscowość"
        ).apply {
          onEvent {
            change = {
              field.miejscowosc = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) ) },
        POLE_WYMAGANE
      ))
      add(
        Text(//VALIDATION TUlica ( MAX 65)
          value = field.ulica,
          label = "Ulica"
        ).apply {
          onEvent {
            change = {
              field.ulica = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        }
      )
      add(
        Text( //VALIDATION TNrBudynku ( MAX 9)
          value = field.nrDomu,
          label = "Nr domu"
        ).apply {
          onEvent {
            change = {
              field.nrDomu = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        }
      )
      add(
        Text( //VALIDATION TNrLokalu ( MAX 10)
          value = field.nrLokalu,
          label = "Nr lokalu"
        ).apply {
          onEvent {
            change = {
              field.nrLokalu = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        }
      )
    }
  }

  fun fieldsetPanelOsobaFizyczna(field: OsobaFizyczna): FieldsetPanel {
    return FieldsetPanel("Osoba fizyczna").apply {
      add(dynamicFieldsValidator.add(
        Text( //VALIDATION TImie ( MAX 30)
          value = field.imie,
          label = "Imie"
        ).apply {
          onEvent {
            change = {
              field.imie = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank())) },
        POLE_WYMAGANE
      ))
      add(dynamicFieldsValidator.add(
        Text(
          value = field.nazwisko,
          label = "Nazwisko"
        ).apply {
          onEvent {
            change = {
              field.nazwisko = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank())) },
        POLE_WYMAGANE
      ))
      add(fieldsetPanelAdres(field.adres))

      add(admIdOsobaFizyczna(field.admId))
      add(dynamicFieldsValidator.add(
        Text(
          value = field.nrTelefonu,
          label = "Numer telefonu"
        ).apply {
          onEvent {
            change = {
              field.nrTelefonu = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        },
        { elem -> (elem.isNullOrEmpty() || elem.isBlank() || ("\\+?[0-9]+([- ][0-9]+)*")?.toRegex()?.matches(elem) == true) },
        "Niepoprawny numer telefonu"
      )) //arrayOf("\\+?[0-9]+([- ][0-9]+)*", "Niepoprawny numer telefonu")

      add(dynamicFieldsValidator.add(
        Text(
          value = field.email,
          label = "Email"
        ).apply {
          onEvent {
            change = {
              field.email = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        },
        { elem -> (elem.isNullOrEmpty() || elem.isBlank() || ("^[\\w!#$%&'*+/=?`{|}~^-]+(?:\\.[\\w!#$%&'*+/=?`{|}~^-]+)*@(?!-)(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")?.toRegex()?.matches(elem) == true) },
        "Adres e-mail jest niepoprawny"
      ))//"^[\\w!#$%&'*+/=?`{|}~^-]+(?:\\.[\\w!#$%&'*+/=?`{|}~^-]+)*@(?!-)(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$", "Adres e-mail jest niepoprawny"

      add(dateField(
        field = field.dataUrodzenia,
        label = "Data urodzenia",
        required = false
      ))

      add(dynamicFieldsValidator.add(
        Text(//VALIDATION TImie ( MAX 30)
          value = field.imieMatki,
          label = "Imie matki"
        ).apply {
          onEvent {
            change = {
              field.imieMatki = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank())) },
        POLE_WYMAGANE
      ))
      add(dynamicFieldsValidator.add(
        Text(//VALIDATION TImie ( MAX 30)
          value = field.imieOjca,
          label = "Imie ojca"
        ).apply {
          onEvent {
            change = {
              field.imieOjca = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank())) },
        POLE_WYMAGANE
      ))
      add(dynamicFieldsValidator.add(
        Text(
          value = field.skrytkaEPuap,
          label = "Adres skrzynki ePUAP"
        ).apply {
          onEvent {
            change = {
              field.skrytkaEPuap = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        },//arrayOf("(/)[a-zA-Z0-9\\-_]{3,100}(/)[a-zA-Z0-9\\-_]{2,100}", "Błędny adres akrzynki ePUAP. przykładowy adres: \"/adres/skrzynki\"")
        { elem -> ( ((elem.isNullOrEmpty() || elem.isBlank()) || ("(/)[a-zA-Z0-9\\-_]{3,100}(/)[a-zA-Z0-9\\-_]{2,100}")?.toRegex()?.matches(elem) == true) ) },
        "Błędny adres akrzynki ePUAP. przykładowy adres: \"/adres/skrzynki\""
      ))
    }
  }

  fun fieldsetPanelOsobaNiefizyczna(field: OsobaNiefizyczna): FieldsetPanel {
    return FieldsetPanel("Podmiot niebędący osobą fizyczną").apply {
      add(dynamicFieldsValidator.add(
        Text(
          value = field.nazwa,
          label = "Nazwa"
        ).apply {
          onEvent {
            change = {
              field.nazwa = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          flabel.addCssClass("required-label")
        },
        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank())) },
        POLE_WYMAGANE
      ))
      add(fieldsetPanelAdres(field.adres))
      add(admIdOsobaNiefizyczna(field.admId))
      add(dynamicFieldsValidator.add(
        Text(
          value = field.nrTelefonu,
          label = "Numer telefonu"
        ).apply {
          onEvent {
            change = {
              field.nrTelefonu = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        },
        { elem -> (elem.isNullOrEmpty() || elem.isBlank() || ("\\+?[0-9]+([- ][0-9]+)*")?.toRegex()?.matches(elem) == true) },
        "Niepoprawny numer telefonu"
      )) //arrayOf("\\+?[0-9]+([- ][0-9]+)*", "Niepoprawny numer telefonu")

      add(dynamicFieldsValidator.add(
        Text(
          value = field.email,
          label = "Email"
        ).apply {
          onEvent {
            change = {
              field.email = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        },
        { elem -> (elem.isNullOrEmpty() || elem.isBlank() || ("^[\\w!#$%&'*+/=?`{|}~^-]+(?:\\.[\\w!#$%&'*+/=?`{|}~^-]+)*@(?!-)(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")?.toRegex()?.matches(elem) == true) },
        "Adres e-mail jest niepoprawny"
      ))//"^[\\w!#$%&'*+/=?`{|}~^-]+(?:\\.[\\w!#$%&'*+/=?`{|}~^-]+)*@(?!-)(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$", "Adres e-mail jest niepoprawny"

      add(dynamicFieldsValidator.add(
        Text(
          value = field.skrytkaEPuap,
          label = "Adres skrzynki ePUAP"
        ).apply {
          onEvent {
            change = {
              field.skrytkaEPuap = self.value
            }
          }
          styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
        },//arrayOf("(/)[a-zA-Z0-9\\-_]{3,100}(/)[a-zA-Z0-9\\-_]{2,100}", "Błędny adres akrzynki ePUAP. przykładowy adres: \"/adres/skrzynki\"")
        { elem -> ( ((elem.isNullOrEmpty() || elem.isBlank()) || ("(/)[a-zA-Z0-9\\-_]{3,100}(/)[a-zA-Z0-9\\-_]{2,100}")?.toRegex()?.matches(elem) == true) ) },
        "Błędny adres akrzynki ePUAP. przykładowy adres: \"/adres/skrzynki\""
      ))

      add(CheckBox(
        value = field.wSpadku,
        label = "W spadku",
        rich = true
      ).apply {
        onEvent {
          change = {
            field.wSpadku = self.value
          }
        }
      })
    }
  }

  private fun admIdOsobaFizyczna(admId: AdmIdOsobaFizyczna): FieldsetPanel {
    val validationGroup = Util.getRandomString()
    return FieldsetPanel("Identyfikatory").apply {
      var identyfikatory = Div().apply {
        visible = !admId.oswiadczenieWierzyciela

        var pesel = dynamicFieldsValidator.add(
          Text(//validation TNrPESEL pattern "\\d{11}"
          value = admId.pesel,
          label = "PESEL"
          ).apply {
            onEvent {
              change = {
                admId.pesel = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          },
          { elem -> (!elem.isNullOrEmpty() && !elem.isBlank() && ("\\d{11}")?.toRegex()?.matches(elem) == true) },
          { elem -> (if( !elem.isNullOrEmpty() && !elem.isBlank() ) "Wartość powinna zawierać 11 cyfr" else POLE_WYMAGANE) },
          "admIdOsobaFizycznaPESEL$validationGroup"
        )
        var nip = dynamicFieldsValidator.add(
          Text(
            value = admId.nip,
            label = "NIP"
          ).apply {
            onEvent {
              change = {
                admId.nip = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          },
          { elem -> (!elem.isNullOrEmpty() && !elem.isBlank() && ("[1-9]((\\d[1-9])|([1-9]\\d))\\d{7}")?.toRegex()?.matches(elem) == true) },
          { elem -> (if( !elem.isNullOrEmpty() && !elem.isBlank() ) "Wartość powinna zawierać 10 cyfr" else POLE_WYMAGANE) },
          "admIdOsobaFizycznaNIP$validationGroup"
        )
        var innyIdentyfikator = dynamicFieldsValidator.add(
          Text(
            value = admId.innyIdentyfikator,
            label = "Inny identyfikator"
          ).apply {
            onEvent {
              change = {
                admId.innyIdentyfikator = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          },
          { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
          POLE_WYMAGANE,
          "admIdOsobaFizycznaInnyIdentyfikator$validationGroup"
        )
        add(dynamicFieldsValidator.add(
          Select(
            value = admId.identyfikatorGlowny,
            label = "Główny identyfikator"
          ).apply {
            emptyOption = true
            onEvent {
              change = {
                admId.identyfikatorGlowny = self.value
                admIdOsobaFizycznaChangeRequiredId(self.value, pesel, nip, innyIdentyfikator, validationGroup)
              }
            }
            for ((key, value) in EzwData.listOfAdmIdNaturalPerson) {
              selectOption(value = key.toString(),label = value)
              liveSearch = true
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
            flabel.addCssClass("required-label")
          },
          { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank())) },
          POLE_WYMAGANE
        ))
        admIdOsobaFizycznaChangeRequiredId(admId.identyfikatorGlowny, pesel, nip, innyIdentyfikator, validationGroup)

        add(pesel)
        add(nip)
        add(innyIdentyfikator)
      }
      add(identyfikatory)
      add(CheckBox(//Checkbox: oswiadczenieWierzyciela
        value = admId.oswiadczenieWierzyciela,
        label = "Oświadczenie Wierzyciela",
        rich = true
      ).apply {
        onEvent {
          change = {
            admId.oswiadczenieWierzyciela = self.value
            if (self.value) {
              identyfikatory.hide()
            } else {
              identyfikatory.show()
            }
          }
        }
      })
      add(Label("Treść oświadczenia: Wierzyciel oświadcza, że dokonał sprawdzenia na obecność posiadania przez podmiot identyfikatorów PESEL, NIP oraz innych identyfikatorów. Podmiot nie posiada wskazanych identyfikatorów lub nie było możliwości ich ustalenia."))
    }
  }

  private fun admIdOsobaFizycznaChangeRequiredId(identyfikatorGlowny: String?, pesel: FormControl, nip: FormControl, innyIdentyfikator: FormControl, validationGroup: String) {
    when(identyfikatorGlowny) {
      "0" -> {
        pesel.flabel.addCssClass("required-label")
        nip.flabel.removeCssClass("required-label")
        innyIdentyfikator.flabel.removeCssClass("required-label")
        dynamicFieldsValidator.removeNotValidationGroup("admIdOsobaFizycznaPESEL$validationGroup")
        dynamicFieldsValidator.addNotValidationGroup("admIdOsobaFizycznaNIP$validationGroup")
        dynamicFieldsValidator.addNotValidationGroup("admIdOsobaFizycznaInnyIdentyfikator$validationGroup")
        pesel.validatorError = null
        nip.validatorError = null
        innyIdentyfikator.validatorError = null
      }
      "1" -> {
        pesel.flabel.removeCssClass("required-label")
        nip.flabel.addCssClass("required-label")
        innyIdentyfikator.flabel.removeCssClass("required-label")
        dynamicFieldsValidator.addNotValidationGroup("admIdOsobaFizycznaPESEL$validationGroup")
        dynamicFieldsValidator.removeNotValidationGroup("admIdOsobaFizycznaNIP$validationGroup")
        dynamicFieldsValidator.addNotValidationGroup("admIdOsobaFizycznaInnyIdentyfikator$validationGroup")
        pesel.validatorError = null
        nip.validatorError = null
        innyIdentyfikator.validatorError = null
      }
      "2" -> {
        pesel.flabel.removeCssClass("required-label")
        nip.flabel.removeCssClass("required-label")
        innyIdentyfikator.flabel.addCssClass("required-label")
        dynamicFieldsValidator.addNotValidationGroup("admIdOsobaFizycznaPESEL$validationGroup")
        dynamicFieldsValidator.addNotValidationGroup("admIdOsobaFizycznaNIP$validationGroup")
        dynamicFieldsValidator.removeNotValidationGroup("admIdOsobaFizycznaInnyIdentyfikator$validationGroup")
        pesel.validatorError = null
        nip.validatorError = null
        innyIdentyfikator.validatorError = null
      }
    }
  }

  private fun admIdOsobaNiefizyczna(admId: AdmIdOsobaNiefizyczna): FieldsetPanel {
    val validationGroup = Util.getRandomString()
    return FieldsetPanel("Identyfikatory").apply {
      var identyfikatory = Div().apply {
        visible = !admId.oswiadczenieWierzyciela

        var nip = dynamicFieldsValidator.add(
          Text(
            value = admId.nip,
            label = "NIP"
          ).apply {
            onEvent {
              change = {
                admId.nip = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          },
          { elem -> (!elem.isNullOrEmpty() && !elem.isBlank() && ("[1-9]((\\d[1-9])|([1-9]\\d))\\d{7}")?.toRegex()?.matches(elem) == true) },
          { elem -> (if( !elem.isNullOrEmpty() && !elem.isBlank() ) "Wartość powinna zawierać 10 cyfr" else POLE_WYMAGANE) },
          "admIdOsobaNiefizycznaNIP$validationGroup"
        )
        var regon = dynamicFieldsValidator.add(Text(
            value = admId.regon,
            label = "REGON"
          ).apply {
            onEvent {
              change = {
                admId.regon = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          },
          { elem -> (!elem.isNullOrEmpty() && !elem.isBlank() && ("^(\\d{9}|\\d{14})$")?.toRegex()?.matches(elem) == true) },
          { elem -> (if( !elem.isNullOrEmpty() && !elem.isBlank() ) "Wartość powinna zawierać 9 lub 14 cyfr" else POLE_WYMAGANE) },
          "admIdOsobaNiefizycznaREGON$validationGroup"
        )
        var krs = dynamicFieldsValidator.add(
          Text(
            value = admId.krs,
            label = "KRS"
          ).apply {
            onEvent {
              change = {
                admId.krs = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          },
          { elem -> (!elem.isNullOrEmpty() && !elem.isBlank() && ("\\d{10}")?.toRegex()?.matches(elem) == true) },
          { elem -> (if( !elem.isNullOrEmpty() && !elem.isBlank() ) "Wartość powinna zawierać 10 cyfr" else POLE_WYMAGANE) },
          "admIdOsobaNiefizycznaKRS$validationGroup"
        )
        var innyIdentyfikator = dynamicFieldsValidator.add(
          Text(
            value = admId.innyIdentyfikator,
            label = "Inny identyfikator"
          ).apply {
            onEvent {
              change = {
                admId.innyIdentyfikator = self.value
              }
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
          },
          { elem -> (!elem.isNullOrEmpty() && !elem.isBlank()) },
          POLE_WYMAGANE,
          "admIdOsobaNiefizycznaInnyIdentyfikator$validationGroup"
        )
        add(dynamicFieldsValidator.add(
          Select(
            value = admId.identyfikatorGlowny,
            label = "Główny identyfikator"
          ).apply {
            emptyOption = true
            onEvent {
              change = {
                admId.identyfikatorGlowny = self.value
                admIdOsobaNiefizycznaChangeRequiredId(self.value, nip, regon, krs, innyIdentyfikator, validationGroup)
              }
            }
            for ((key, value) in EzwData.listOfAdmIdNonPhisicalPerson) {
              selectOption(value = key.toString(),label = value)
              liveSearch = true
            }
            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
            flabel.addCssClass("required-label")
          },
          { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank())) },
          POLE_WYMAGANE
        ))
        admIdOsobaNiefizycznaChangeRequiredId(admId.identyfikatorGlowny, nip, regon, krs, innyIdentyfikator, validationGroup)

        add(nip)
        add(regon)
        add(krs)
        add(innyIdentyfikator)
      }
      add(identyfikatory)
      add(CheckBox(//Checkbox: oswiadczenieWierzyciela
        value = admId.oswiadczenieWierzyciela,
        label = "Oświadczenie Wierzyciela",
        rich = true
      ).apply {
        onEvent {
          change = {
            admId.oswiadczenieWierzyciela = self.value
            if (self.value) {
              identyfikatory.hide()
            } else {
              identyfikatory.show()
            }
          }
        }
      })
      add(Label("Treść oświadczenia: Wierzyciel oświadcza, że dokonał sprawdzenia na obecność posiadania przez podmiot identyfikatorów NIP, REGON, KRS i innych identyfikatorów. Podmiot nie posiada wskazanych identyfikatorów lub nie było możliwości ich ustalenia."))
    }
  }

  private fun admIdOsobaNiefizycznaChangeRequiredId(identyfikatorGlowny: String?, nip: FormControl, regon: FormControl, krs: FormControl, innyIdentyfikator: FormControl, validationGroup: String) {
    when(identyfikatorGlowny) {
      "0" -> {
        nip.flabel.addCssClass("required-label")
        regon.flabel.removeCssClass("required-label")
        krs.flabel.removeCssClass("required-label")
        innyIdentyfikator.flabel.removeCssClass("required-label")
        dynamicFieldsValidator.removeNotValidationGroup("admIdOsobaNiefizycznaNIP$validationGroup")
        dynamicFieldsValidator.addNotValidationGroup("admIdOsobaNiefizycznaREGON$validationGroup")
        dynamicFieldsValidator.addNotValidationGroup("admIdOsobaNiefizycznaKRS$validationGroup")
        dynamicFieldsValidator.addNotValidationGroup("admIdOsobaNiefizycznaInnyIdentyfikator$validationGroup")
        nip.validatorError = null
        regon.validatorError = null
        krs.validatorError = null
        innyIdentyfikator.validatorError = null
      }
      "1" -> {
        nip.flabel.removeCssClass("required-label")
        regon.flabel.addCssClass("required-label")
        krs.flabel.removeCssClass("required-label")
        innyIdentyfikator.flabel.removeCssClass("required-label")
        dynamicFieldsValidator.addNotValidationGroup("admIdOsobaNiefizycznaNIP$validationGroup")
        dynamicFieldsValidator.removeNotValidationGroup("admIdOsobaNiefizycznaREGON$validationGroup")
        dynamicFieldsValidator.addNotValidationGroup("admIdOsobaNiefizycznaKRS$validationGroup")
        dynamicFieldsValidator.addNotValidationGroup("admIdOsobaNiefizycznaInnyIdentyfikator$validationGroup")
        nip.validatorError = null
        regon.validatorError = null
        krs.validatorError = null
        innyIdentyfikator.validatorError = null
      }
      "2" -> {
        nip.flabel.removeCssClass("required-label")
        regon.flabel.removeCssClass("required-label")
        krs.flabel.addCssClass("required-label")
        innyIdentyfikator.flabel.removeCssClass("required-label")
        dynamicFieldsValidator.addNotValidationGroup("admIdOsobaNiefizycznaNIP$validationGroup")
        dynamicFieldsValidator.addNotValidationGroup("admIdOsobaNiefizycznaREGON$validationGroup")
        dynamicFieldsValidator.removeNotValidationGroup("admIdOsobaNiefizycznaKRS$validationGroup")
        dynamicFieldsValidator.addNotValidationGroup("admIdOsobaNiefizycznaInnyIdentyfikator$validationGroup")
        nip.validatorError = null
        regon.validatorError = null
        krs.validatorError = null
        innyIdentyfikator.validatorError = null
      }
      "3" -> {
        nip.flabel.removeCssClass("required-label")
        regon.flabel.removeCssClass("required-label")
        krs.flabel.removeCssClass("required-label")
        innyIdentyfikator.flabel.addCssClass("required-label")
        dynamicFieldsValidator.addNotValidationGroup("admIdOsobaNiefizycznaNIP$validationGroup")
        dynamicFieldsValidator.addNotValidationGroup("admIdOsobaNiefizycznaREGON$validationGroup")
        dynamicFieldsValidator.addNotValidationGroup("admIdOsobaNiefizycznaKRS$validationGroup")
        dynamicFieldsValidator.removeNotValidationGroup("admIdOsobaNiefizycznaInnyIdentyfikator$validationGroup")
        nip.validatorError = null
        regon.validatorError = null
        krs.validatorError = null
        innyIdentyfikator.validatorError = null
      }
    }
  }

}
